module.exports = __webpack_public_path__ + "fonts/aktivgrotesk-thin-webfont.13ac6672.woff";